var serviceUrls = {
    AUTH: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'https://localhost:5001';
                case 'uat':
                    return 'https://auth.services.oncolens.dev';
                case 'staging':
                    return 'https://auth.services.staging.oncolens.com';
                case 'staging-sa':
                    return 'https://auth.services.staging.sa.oncolens.com';
                case 'prod-sa':
                    return 'https://auth.services.sa.oncolens.com';
                case 'prod-beta':
                    return 'https://auth.services.beta.oncolens.com';
                case 'prod':
                    return 'https://auth.services.oncolens.com';
                case 'prod-eu':
                    return 'https://auth.services.eu.oncolens.com';
                default:
                    // TODO change this to properly set env variable config on start
                    return 'https://localhost:5001';
            }
        },
    },
    WEB_ONCOLENS: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'http://localhost:8100';
                case 'uat':
                    return 'https://app.oncolens.dev';
                case 'staging':
                    return 'https://app.staging.oncolens.com';
                case 'staging-sa':
                    return 'https://app.staging.sa.oncolens.com';
                case 'prod-sa':
                    return 'https://app.sa.oncolens.com';
                case 'prod':
                    return 'https://app.oncolens.com';
                case 'prod-beta':
                    return 'https://app.beta.oncolens.com';
                case 'prod-eu':
                    return 'https://app.eu.oncolens.com';
                default:
                    // TODO change this to properly set env variable config on start
                    return 'http://localhost:8100';
            }
        },
    },
    USERS_API: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'https://localhost:5003';
                case 'uat':
                    return 'https://users.services.oncolens.dev';
                case 'staging':
                    return 'https://users.services.staging.oncolens.com';
                case 'staging-sa':
                    return 'https://users.services.staging.sa.oncolens.com';
                case 'prod-sa':
                    return 'https://users.services.sa.oncolens.com';
                case 'prod':
                    return 'https://users.services.oncolens.com';
                case 'prod-beta':
                    return 'https://users.services.beta.oncolens.com';
                case 'prod-eu':
                    return 'https://users.services.eu.oncolens.com';
                default:
                    return 'https://localhost:5003';
            }
        },
    },
    CORE_DOMAIN_API: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'https://localhost:5005';
                case 'uat':
                    return 'https://coredomain.services.oncolens.dev';
                case 'staging':
                    return 'https://coredomain.services.staging.oncolens.com';
                case 'staging-sa':
                    return 'https://coredomain.services.staging.sa.oncolens.com';
                case 'prod-sa':
                    return 'https://coredomain.services.sa.oncolens.com';
                case 'prod':
                    return 'https://coredomain.services.oncolens.com';
                case 'prod-beta':
                    return 'https://coredomain.services.beta.oncolens.com';
                case 'prod-eu':
                    return 'https://coredomain.services.eu.oncolens.com';
                default:
                    return 'https://localhost:5005';
            }
        },
    },
    BIOMARKERS_API: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'http://localhost:8080';
                case 'uat':
                    return 'https://biomarkers.services.oncolens.dev';
                case 'staging':
                    return 'https://biomarkers.services.staging.oncolens.com';
                case 'prod':
                case 'prod-beta':
                    return 'https://biomarkers.services.oncolens.com';
                case 'prod-eu':
                    return 'https://biomarkers.services.eu.oncolens.com';
                default:
                    return 'http://localhost:8080';
            }
        },
    },
    FRESH_DESK: {
        BASE: function () {
            var _a;
            // @ts-ignore
            switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
                case 'dev':
                    return 'https://oncolensdev.freshdesk.com/customer/login';
                case 'uat':
                    return 'https://oncolensdev.freshdesk.com/customer/login';
                case 'staging':
                case 'staging-sa':
                case 'prod-sa':
                case 'prod-eu':
                case 'prod-beta':
                case 'prod':
                    return 'https://support.oncolens.com/customer/login';
                default:
                    return 'https://oncolensdev.freshdesk.com/customer/login';
            }
        },
    },
    ADMIN: function () {
        var _a;
        // @ts-ignore
        switch (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV)) {
            case 'uat':
                return 'https://admin.services.oncolens.dev';
            case 'staging':
                return 'https://admin.services.staging.oncolens.com';
            case 'staging-sa':
                return 'https://admin.services.staging.sa.oncolens.com';
            case 'prod-sa':
                return 'https://admin.services.sa.oncolens.com';
            case 'prod':
                return 'https://admin.services.oncolens.com';
            case 'prod-beta':
                return 'https://admin.services.beta.oncolens.com';
            case 'prod-eu':
                return 'https://admin.services.eu.oncolens.com';
            default:
                return 'https://localhost:5015';
        }
    },
};
export default serviceUrls;
